export const situationsFour = [
  {
    id: 1,
    text: "His family members had fixed his marriage but his commanding officer detailed him for an adventure activity. He...",
    response:
      " He informed CO about marriage, assured adventure activity after coming back, convinced and got the leave. ",
  },
  {
    id: 2,
    text: "All the members of his family wanted him to come on leave for a social party. He...",
    response:
      "Politely declined and went home on his scheduled leave and hosted another social gathering.",
  },
  {
    id: 3,
    text: "While passing through a lane, he saw some person beating a girl. He...",
    response:
      "He confronted with passerby help, nabbed them and handed over to the police and helped the girl in lodging complaint.",
  },
  {
    id: 4,
    text: "The very family who borrowed a gas cylinder from him refused to lend their's when he needed it most. He...",
    response:
      "He contacted his friends, arranged cylinder and returned new cylinder after delivery.",
  },
  {
    id: 5,
    text: "His subordinates call him as an informer of subedar Major. He...",
    response:
      "He refused their claim and won their confidence with his leadership.",
  },
  {
    id: 6,
    text: "Your brother switches off the TV while you were watching an interesting program. You...",
    response: "Told not to tease and switched it on and enjoyed the program.",
  },
  {
    id: 7,
    text: "Your immediate senior at your office took all the credit for your job. You...",
    response:
      "Contacted the HR, showed my work and took the right credit for it.",
  },
  {
    id: 8,
    text: "You were criticized for a job which you performed. You will...",
    response:
      " Learnt from criticism, incorporated in work and gained confidence.",
  },
  {
    id: 9,
    text: "You are a good singer, you belong to a different religion, the other community persons asked you to sing songs on the praise of their lord. You...",
    response: "Sang the song and got praise from everyone.",
  },
  {
    id: 10,
    text: "The train TTE was asking you for extra money to allot a vacant berth in the train. You...",
    response:
      "I explained the situation, convinced him for fine and paid the amount.",
  },
  {
    id: 11,
    text: "While climbing a wall with the help of a rope, the rope breaks up and you start falling. You will...",
    response:
      "Jumped safely on the ground, brought a ladder and climbed again.",
  },
  {
    id: 12,
    text: "You are invited for a job interview by a company but on reaching there you heard that a person is already working against the vacancy for which you are called for. You...",
    response:
      "Contacted HR and cleared all doubts, gave the interview and got the job.",
  },
  {
    id: 13,
    text: "You are traveling in the train and two passengers are discussing the Kashmir problem and one is supporting Pakistan. You would...",
    response:
      "Volunteered for healthy discussion, put his views forward and helped change his outlook.",
  },
  {
    id: 14,
    text: "You are passing by a well and see a woman crying she says that her son has fallen into the well and no one is there to help around. You would...",
    response:
      "Gathered people, took a rope from somewhere, threw into the well and took out her son.",
  },
  {
    id: 15,
    text: "Your neighboring house catches fire at midnight at a time when you have to get your mother admitted in a hospital. You would...",
    response:
      "Asked father to take mother to the hospital, called fire brigade and ambulance and helped in evacuation and extinguishing.",
  },
  {
    id: 16,
    text: "He as head of an office observes that one of his subordinates is in the habit of coming late to the office every day. He will...",
    response: "He inquired the reason and directed him to come on time.",
  },
  {
    id: 17,
    text: "He notices that some of his staff members in the office are conspiring to let him down in the eyes of his boss. He will...",
    response:
      "Became cautious and vigilant and didn't give any room for their plan to succeed..",
  },
  {
    id: 18,
    text: "While going on leave from his duty station, he finds two jawans of his unit having boarded the train without appropriate leave. The train is about to steam off. He...",
    response:
      "He ordered them to report immediately to the unit and took disciplinary action. ",
  },
  {
    id: 19,
    text: "While traveling from one place to another. He observes that two suspicious-looking persons alight the bus leaving behind a box under their seat. He will...",
    response: "He alerted the passengers, evacuated the bus and called police.",
  },
  {
    id: 20,
    text: "He while on posting from one place to another is offered reservation along with a young lonely lady. He will...",
    response: "He made her friend and enjoyed the company.",
  },
  {
    id: 21,
    text: "Her friend loved a boy. She knew about his characterless nature. She would...",
    response:
      " She told to her about it and convinced her to think about it before committing and decide accordingly.",
  },
  {
    id: 22,
    text: "Her friend would like to marry a boy who is still unemployed. She would...",
    response: "Helped the boy find a good job.",
  },

  {
    id: 23,
    text: "He was on his way to Delhi from Shillong. When suddenly one wheel of his car got punctured. To his dismay, he found, there was no spare wheel either. He yet had a long way to go. He...",
    response:
      " He parked his car at a safe place, took help from a passerby, took the wheel, got it repaired and continued journey.",
  },
  {
    id: 24,
    text: "He had just completed his 20th year when his father wanted him to get married but he thought it was too early to do so. He...",
    response:
      "He asked for time and told about his career plan, convinced him and pursued his dream.",
  },
  {
    id: 25,
    text: "The car in which he was traveling struck against a bullock cart coming from the opposite direction as bulls went out of control. He...",
    response:
      "He remained inside the car, wait for the bull to calm and drive away.",
  },
  {
    id: 26,
    text: "All the members of his family wanted him to come on leave for a party for his brother’s top rank in IIT, when he has to lead his volleyball team for a match on the same day. He...",
    response:
      "Congratulated brother over the phone, lead the team, won the match and later went home and celebrated together..",
  },
  {
    id: 27,
    text: "He went to college for exam and found his name missing in the list. He...",
    response:
      " He showed admit card to the invigilator, took permission from the examiner and gave the exam.",
  },
  {
    id: 28,
    text: "He is in urgent need of birth certificate at Taluk office but the clerk asks him for some bribe for urgent delivery. He...",
    response:
      "He complaint to a nodal officer, took his assistance and got the certificate.",
  },
  {
    id: 29,
    text: "After her graduation, she gets high paid job offer at the same time she gets a seat for a masters degree at Government college. She...",
    response:
      "Took admission in the college, completed the degree and took a better job.",
  },
  {
    id: 30,
    text: "On the arrival to SSB, he found the candidate line is not clean and comfortable to stay. He...",
    response:
      "He cleaned his bedding, got settled and informed caretaker about the room.",
  },
  {
    id: 31,
    text: "He is in love with a girl, he aspires to become an Army officer but she said she would not marry an army officer as the risk is high. He...",
    response:
      " He talked to her, told her about the life and dignity of an Army officer and convinced her.",
  },
  {
    id: 32,
    text: "He has gone to buy a book for his exam which is on the next week. But the book is out of stock. He...",
    response: "Downloaded the PDF and printed it out.",
  },
  {
    id: 33,
    text: "He wanted to carry extra rum bottles for his sister's marriage but canteen officer refused to give him. He...",
    response: "Took it on his colleague’s card.",
  },
  {
    id: 34,
    text: "A swimming competition is being conducted in his college, and he is in charge of it. All of sudden someone from the audience shouts 'snake. He...",
    response: "He directed the team to find and kill the snake.",
  },
  {
    id: 35,
    text: "He is asked to join the army soon as war is imminent but his grandmother is on death bed. He...",
    response: " He took blessings of his grandmother and joined the unit.",
  },
  {
    id: 36,
    text: "He is in the weather department and get the news that the forthcoming rains may cause floods. He...",
    response:
      "He circulated alert to the state home departments and directed them to take measures. ",
  },
  {
    id: 37,
    text: "He is asked by his boss to favor him with a loan of 5000 from the institutional funds which he thinks is not legitimate. He will...",
    response: "He denied and told him to take a loan as per company's rule.",
  },
  {
    id: 38,
    text: "He comes across a stranger who informs him of some people in the village planning to destroy some public property. He will...",
    response: "He informed the police and prevented any destruction.",
  },
  {
    id: 39,
    text: "He has plenty of time during his summer vacations. He will...",
    response:
      "He will read books, do physical activities and inculcate new habits and hang out with friends.",
  },
  {
    id: 40,
    text: "He has strained relations with his neighbor over an issue. He will...",
    response:
      "He arranged meeting, had a conversation, removed grudges and established cordial relations.",
  },
  {
    id: 41,
    text: "While putting off fire in his neighborhood, he is implicated by his neighbor to have set the fire. He...",
    response: "He talked to his neighbor and cleared the misconception.",
  },
  {
    id: 42,
    text: "A close relation of yours is seriously injured in communal riots. You would...",
    response:
      "Took him to the hospital, lodged a complaint and took care of him.",
  },
  {
    id: 43,
    text: "You like to meet people because...",
    response:
      "They helps in developing personality and widens the scope of thought process. ",
  },
  {
    id: 44,
    text: "You read the editorial page of the newspaper because...",
    response:
      "It gives wider perspective and keeps one intact with the current situation with deep analysis. ",
  },
  {
    id: 45,
    text: "You find a body on the seashore. What would you do...",
    response:
      "Informed coast guard, told them about everything and helped in the investigation.",
  },
  {
    id: 46,
    text: "You and your friend returning home from college and find a man pouring kerosene oil on himself and about to light a match to self immolate himself. You....",
    response:
      "I ran and took the container and match stick away from his hand and informed his family members.",
  },
  {
    id: 47,
    text: "Mention three differences between Hostel life and day Scholar...",
    response:
      "Partly dependent and independent; partly teamwork and totally team; less time for expansion and always surrounded by different people thereby getting time to diverse fully.",
  },
  {
    id: 48,
    text: "One of your colleagues has been caught red-handed while taking bribe by a policeman. You would...",
    response: "Cooperated with the police as per their directions.",
  },
  {
    id: 49,
    text: "You lose the election of the president of college union and a president elected offers you a post under him in the students union. You...",
    response: "Politely declined the offer and prepared for next election.",
  },
  {
    id: 50,
    text: "You see Terrorists blowing a bridge on a highway next to your village. You would...",
    response:
      "Immediately called police, alerted the passerby and helped police in neutralizing them. ",
  },
  {
    id: 51,
    text: "He has to meet deputy commissioner urgently, but he is busy today. He...",
    response:
      "Told his urgency to the office staff and try to get an appointment in his break time.",
  },
  {
    id: 52,
    text: "He feels strongly that a person can achieve a lot if he...",
    response: "He is disciplined, self-motivated, calm and cheerful.",
  },
  {
    id: 53,
    text: "He finds a person lying flat on the ground and many people have surrounded him. He would ...",
    response:
      "He went close, inquired about the situation and called an ambulance if need medical assistance.",
  },
  {
    id: 54,
    text: "While on annual leave, he finds that his agricultural land has been occupied by the neighbor. When negotiating they threatened to kill him. They are notorious people of the village. He...",
    response:
      "He lodge FIR, asked for police protection and got them arrested and got them removed from the land.",
  },
  {
    id: 55,
    text: "He is a notorious student in the college. Due to some misunderstanding, the principal decides to rusticate him for three years. He...",
    response:
      "Proved his innocence with proof and removed the misunderstanding.",
  },
  {
    id: 56,
    text: "What if someone threatened to kill you...",
    response:
      "Lodge FIR and give a statement before Magistrate and got them arrested.",
  },
  {
    id: 57,
    text: "You are a senior in your college and found some of your friends ragging the fresher batch. You would...",
    response:
      "I confronted them and told them to stop and if not, complaint to the authority.",
  },
  {
    id: 58,
    text: "You learned that your best friend is gonna fight a group of people and you are finding it hard to resolve the matter with talking. You would...",
    response:
      "Informed parents and police, stopped them and hold talk in front police and resolved the matter.",
  },
  {
    id: 59,
    text: "You asked your friend for a helping hand in your sister's wedding but he refused. You would...",
    response: "Took it lightly and seeks help from other friends and relatives",
  },
  {
    id: 60,
    text: "You have broken a serious rule of your unit but no one has noticed yet. You would...",
    response: "Informed company commander and volunteered for further action.",
  },
];
